import React from "react";
import { Box, Typography } from "@mui/material";
import { monoFontSx } from "../ThemeContext";

/**
 * Small KPI tile shared by VehicleHeroCard and InsightsDashboard, so
 * numeral styling (see monoFontSx) only needs to be applied in one place.
 */
function StatTile({ label, value, icon, sublabel, mono = true, accent = false }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.5, color: "text.secondary" }}>
        {icon}
        <Typography variant="caption" sx={{ textTransform: "uppercase", letterSpacing: 0.6, fontWeight: 700 }}>
          {label}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.3rem",
          color: accent ? "primary.main" : "text.primary",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          ...(mono ? monoFontSx : {}),
        }}
      >
        {value}
      </Typography>
      {sublabel ? (
        <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.25 }}>
          {sublabel}
        </Typography>
      ) : null}
    </Box>
  );
}

export default StatTile;
